import { effect, inject, Injectable, untracked } from '@angular/core';
import { SimpleProductStepperStore } from '../simple-product-stepper.store';
import { SimpleProductBlockAutoNextStepService } from './simple-product-block-auto-next-step.service';

@Injectable()
export class SimpleProductAutoNextStepService {
  private readonly simpleProductStepperStore = inject(SimpleProductStepperStore);
  private readonly simpleProductBlockAutoNextStepService = inject(
    SimpleProductBlockAutoNextStepService,
  );

  constructor() {
    effect(
      () => {
        // go next step, if the step is valid and the user can not make more choices

        // visitedStep is used to trigger the effect refresh
        const visitedStep = this.simpleProductBlockAutoNextStepService.visitedStep();
        if (!visitedStep) {
          return;
        }
        const blockAutoNextStep = this.simpleProductBlockAutoNextStepService.blockAutoNextStep();
        if (blockAutoNextStep) {
          return;
        }

        const currentStepper = untracked(() => this.simpleProductStepperStore.stepper()?.step);
        if (!currentStepper) {
          return;
        }
        if (!currentStepper.isValid || currentStepper.canMakeMoreChoices) {
          return;
        }

        if (currentStepper.hasNextStep) {
          const nextStep = currentStepper.nextStep;
          if (nextStep) {
            currentStepper.setSelectedStep(nextStep);
          }
          return;
        }
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  public initAutoNextStep() {}
}
